<div>
  <div class="modal-body p-2">
    <div class="content-modal-theme">
      <div class="container-fluid px-0">
        <div id="modalBody" class="d-grid">
          <button
            class="btn-home-hover bg-white position-absolute btn-close-video fw-bold text-blue-100 border-0"
            (click)="activeModal.dismiss()"
          >
            <i class="bi bi-x-lg fw-bold"></i>
          </button>
          <video class="w-100 rounded-4" id="iframe_video" controls [height]="data.height" autoplay>
            <source [src]="this.link" type="video/mp4" />
            Tu navegador no soporta la etiqueta de video.
          </video>
        </div>
      </div>
    </div>
  </div>
</div>
